<template>
  <div
    class="text-body-small flex gap-1 text-left leading-4"
    :class="{
      'text-fgr-secondary': props.variant === 'default',
      'text-fgr-success': props.variant === 'valid',
      'text-fgr-critical': props.variant === 'invalid',
    }"
  >
    <Icon v-if="iconName" :src="iconName" :filled="isFilled" class="!max-h-4" />
    <slot />
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";

  const props = withDefaults(
    defineProps<{
      variant?: "default" | "valid" | "invalid";
    }>(),
    {
      variant: "default",
    }
  );

  const iconName = computed(() => {
    if (props.variant === "valid") return "check_circle";
    if (props.variant === "invalid") return "ExclamationMark";
    return "";
  });

  const isFilled = computed(() => {
    return props.variant === "valid" || props.variant === "default";
  });
</script>
